import { DatePicker, Input } from "antd";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PiCalendarBlankBold } from "react-icons/pi";

import FormItem from "@/components/FormItem";
import { NAMESPACES } from "@/constants/i18next.constants";

import { TBillingOnboardingForm } from "../../MultiStepForm.types";

type TSecondStepProps = {
  control: Control<TBillingOnboardingForm>;
};

function SecondStep({ control }: TSecondStepProps) {
  const { t } = useTranslation([NAMESPACES.BILLING_ONBOARDING]);

  return (
    <>
      <FormItem
        name="paymentDayOffset"
        control={control}
        label={t("billingOnboarding.paymentDayOffsetLabel")}
      >
        <Input
          placeholder={t("billingOnboarding.paymentDayOffsetPlaceholder")}
        />
      </FormItem>
      <FormItem
        name="startTime"
        control={control}
        label={t("billingOnboarding.startTimeLabel")}
      >
        <DatePicker
          format="DD MMMM YYYY"
          size="small"
          placeholder={t("billingOnboarding.startTimePlaceholder")}
          suffixIcon={<PiCalendarBlankBold />}
          style={{
            width: "100%",
          }}
        />
      </FormItem>
      <FormItem
        name="endTime"
        control={control}
        label={t("billingOnboarding.endTimeLabel")}
      >
        <DatePicker
          format="DD MMMM YYYY"
          placeholder={t("billingOnboarding.endTimePlaceholder")}
          style={{
            width: "100%",
          }}
        />
      </FormItem>
    </>
  );
}

export default SecondStep;
